var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRightIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.975 19.012c-.285 0-.538-.095-.728-.285a.976.976 0 0 1 0-1.423l5.348-5.38-5.348-5.346a.976.976 0 0 1 0-1.424.976.976 0 0 1 1.424 0l6.075 6.075a.976.976 0 0 1 0 1.424l-6.075 6.074a.982.982 0 0 1-.696.285"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronRightIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-right-icon.043a5b8030564ff154416a91609ab66b.svg";